import { render } from "./TicketActionCheckboxRow.vue?vue&type=template&id=39fd7874"
import script from "./TicketActionCheckboxRow.vue?vue&type=script&lang=js"
export * from "./TicketActionCheckboxRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__